import type { IShape } from '../shapes/interfaces/IShape';

export class RotateShape {
    private readonly shape: IShape;
    private readonly oldRotation: number;
    private readonly newRotation: number;

    constructor(shape: IShape, oldRotation: number, newRotation: number) {
        this.shape = shape;
        this.oldRotation = oldRotation;
        this.newRotation = newRotation;
    }

    execute(): void {
        this.shape.container.rotation = this.newRotation;
    }

    undo(): void {
        this.shape.container.rotation = this.oldRotation;
    }
}
